/**
 * @generated SignedSource<<341f70450286cb811f24d5f32ca62464>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type StoreProductExpireBatchStatus = "ACTIVE" | "INACTIVE";
import { FragmentRefs } from "relay-runtime";
export type ProductDateTrackerList_Store$data = {
  readonly id: string;
  readonly productExpireBatches: {
    readonly edges: ReadonlyArray<{
      readonly cursor: string;
      readonly node: {
        readonly activeAction: {
          readonly startAtDate: {
            readonly isoString: string;
            readonly timezone: string;
          };
        } | null;
        readonly expireAtDate: {
          readonly isoString: string;
          readonly timezone: string;
          readonly " $fragmentSpreads": FragmentRefs<"StoreRelativeZonedDate_StoreZonedDate">;
        };
        readonly id: string;
        readonly product: {
          readonly id: string;
          readonly imageUrl: string | null;
          readonly name: string | null;
          readonly partNumber: string | null;
          readonly " $fragmentSpreads": FragmentRefs<"ProductExpireBatchProductPreview_StoreProduct" | "ProductHeader_ProductDetails">;
        } | null;
        readonly status: StoreProductExpireBatchStatus;
        readonly " $fragmentSpreads": FragmentRefs<"ProductExpireBatchListItem_StoreProductExpireBatch">;
      };
    }>;
  } | null;
  readonly " $fragmentType": "ProductDateTrackerList_Store";
};
export type ProductDateTrackerList_Store$key = {
  readonly " $data"?: ProductDateTrackerList_Store$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductDateTrackerList_Store">;
};

const node: ReaderFragment = (function(){
var v0 = [
  "productExpireBatches"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isoString",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timezone",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "after"
    },
    {
      "kind": "RootArgument",
      "name": "filter"
    },
    {
      "kind": "RootArgument",
      "name": "first"
    },
    {
      "kind": "RootArgument",
      "name": "order"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": require('./ProductDateTrackerListPaginationQuery.graphql'),
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "ProductDateTrackerList_Store",
  "selections": [
    {
      "alias": "productExpireBatches",
      "args": [
        {
          "kind": "Variable",
          "name": "filter",
          "variableName": "filter"
        },
        {
          "kind": "Variable",
          "name": "orderBy",
          "variableName": "order"
        }
      ],
      "concreteType": "StoreProductExpireBatchConnection",
      "kind": "LinkedField",
      "name": "__ProductDateTracker__productExpireBatches_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "StoreProductExpireBatchEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "StoreProductExpireBatch",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "StoreProductExpireBatchAction",
                  "kind": "LinkedField",
                  "name": "activeAction",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "StoreZonedDate",
                      "kind": "LinkedField",
                      "name": "startAtDate",
                      "plural": false,
                      "selections": [
                        (v2/*: any*/),
                        (v3/*: any*/)
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "ProductExpireBatchListItem_StoreProductExpireBatch"
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "StoreZonedDate",
                  "kind": "LinkedField",
                  "name": "expireAtDate",
                  "plural": false,
                  "selections": [
                    (v2/*: any*/),
                    (v3/*: any*/),
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "StoreRelativeZonedDate_StoreZonedDate"
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "status",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "StoreProduct",
                  "kind": "LinkedField",
                  "name": "product",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "imageUrl",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "partNumber",
                      "storageKey": null
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "ProductHeader_ProductDetails"
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "ProductExpireBatchProductPreview_StoreProduct"
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v1/*: any*/)
  ],
  "type": "Store",
  "abstractKey": null
};
})();

(node as any).hash = "bfc95da6f14be5d0275f906c2e2eae50";

export default node;
